import {
  carsViewTranslation,
  CarsViewTranslation,
} from '@/assets/locales/views/cars/cars.translation.pl.ts';
import {
  chatsViewTranslation,
  ChatsViewTranslation,
} from '@/assets/locales/views/chats/chatsView.translation.pl.ts';
import {
  commissionAdministrationTranslation,
  CommissionAdministrationTranslation,
} from '@/assets/locales/views/commissionAdministration/commissionAdministration.translation.pl.ts';
import {
  commissionConfigurationTranslation,
  CommissionConfigurationTranslation,
} from '@/assets/locales/views/commissionConfiguration/commissionConfiguration.translation.pl.ts';
import {
  commissionsTranslation,
  CommissionsTranslation,
} from '@/assets/locales/views/commissions/commissions.translation.pl.ts';
import {
  componentDefinitionsTranslation,
  ComponentDefinitionsTranslation,
} from '@/assets/locales/views/componentDefinitions/componentDefinitions.translation.pl.ts';
import {
  contactsTranslation,
  ContactsTranslation,
} from '@/assets/locales/views/contacts/contacts.translation.pl.ts';
import {
  contactsCreateTranslation,
  ContactsCreateTranslation,
} from '@/assets/locales/views/contactsCreate/contactsCreate.translation.pl.ts';
import {
  contactsDetailsTranslation,
  ContactsDetailsTranslation,
} from '@/assets/locales/views/contactsDetails/contactsDetails.translation.pl.ts';
import {
  customerDetailsTranslation,
  CustomerDetailsTranslation,
} from '@/assets/locales/views/customerDetails/customerDetails.translation.pl.ts';
import {
  customersViewTranslation,
  CustomersViewTranslation,
} from '@/assets/locales/views/customers/customers.view.translation.pl.ts';
import {
  customersBusinessCreateTranslation,
  CustomersBusinessCreateTranslation,
} from '@/assets/locales/views/customersBusinessCreate/customersBusinessCreate.translation.pl.ts';
import {
  customersForeignCreateTranslation,
  CustomersForeignCreateTranslation,
} from '@/assets/locales/views/customersForeignCreate/customersForeignCreate.translation.pl.ts';
import {
  customersIndividualCreateTranslation,
  CustomersIndividualCreateTranslation,
} from '@/assets/locales/views/customersIndividualCreate/customersIndividualCreate.translation.pl.ts';
import {
  dashboardViewTranslation,
  DashboardViewTranslation,
} from '@/assets/locales/views/dashboard/dashboardView.translation.pl.ts';
import {
  dictionariesViewsTranslation,
  DictionariesViewTranslation,
} from '@/assets/locales/views/dictionaries/dictionaries.translation.pl.ts';
import {
  emailsViewTranslation,
  EmailsViewTranslation,
} from '@/assets/locales/views/emails/emailsView.translation.pl.ts';
import {
  emergencyContactsTranslation,
  EmergencyContactsTranslation,
} from '@/assets/locales/views/emergencyContacts/emergencyContacts.translation.pl.ts';
import {
  failedWorkflowActionsTranslation,
  FailedWorkflowActionsTranslation,
} from '@/assets/locales/views/failedWorkflowActions/failedWorkflowActions.translation.pl.ts';
import {
  offerDefinitionsTranslation,
  OfferDefinitionsTranslation,
} from '@/assets/locales/views/offerDefinitions/offerDefinitions.translation.pl.ts';
import {
  processesTranslation,
  ProcessesTranslation,
} from '@/assets/locales/views/processes/processes.translation.pl.ts';
import {
  ProcessesCreateTranslation,
  processesCreateTranslation,
} from '@/assets/locales/views/processesCreate/processesCreate.translation.pl.ts';
import {
  processesDetailsTranslation,
  ProcessesDetailsTranslation,
} from '@/assets/locales/views/processesDetails/processesDetails.translation.pl.ts';
import {
  ProcessesUpdateTranslation,
  processUpdateTranslation,
} from '@/assets/locales/views/processesUpdate/processesUpdate.translation.pl.ts';
import {
  RecurringReservationsTranslation,
  recurringReservationsTranslation,
} from '@/assets/locales/views/recurringReservations/recurringReservations.translation.pl.ts';
import {
  reportsTranslation,
  ReportsTranslation,
} from '@/assets/locales/views/reports/reports.translation.pl.ts';
import {
  resourceCalendarTranslation,
  ResourceCalendarViewTranslation,
} from '@/assets/locales/views/resourceCalendar/resourceCalendar.translation.pl.ts';
import {
  rolesTranslation,
  RolesTranslation,
} from '@/assets/locales/views/roles/roles.translation.pl.ts';
import {
  supervisorsTranslation,
  SupervisorsTranslation,
} from '@/assets/locales/views/supervisors/supervisors.translation.pl.ts';
import {
  suppliersTranslation,
  SuppliersTranslation,
} from '@/assets/locales/views/suppliers/suppliers.translation.pl.ts';
import {
  tasksTranslations,
  TasksTranslations,
} from '@/assets/locales/views/tasks/tasks.translations.pl.ts';
import {
  usersTranslation,
  UsersTranslation,
} from '@/assets/locales/views/users/users.translation.pl.ts';
import {
  utilViewsTranslation,
  UtilViewsTranslation,
} from '@/assets/locales/views/util/utilViews.translation.pl.ts';

export type ViewsTranslation = {
  cars: CarsViewTranslation;
  chats: ChatsViewTranslation;
  commissionAdministration: CommissionAdministrationTranslation;
  commissionConfiguration: CommissionConfigurationTranslation;
  commissions: CommissionsTranslation;
  componentDefinitions: ComponentDefinitionsTranslation;
  contacts: ContactsTranslation;
  contactsCreate: ContactsCreateTranslation;
  contactsDetails: ContactsDetailsTranslation;
  customerDetails: CustomerDetailsTranslation;
  customers: CustomersViewTranslation;
  customersBusinessCreate: CustomersBusinessCreateTranslation;
  customersForeignCreate: CustomersForeignCreateTranslation;
  customersIndividualCreate: CustomersIndividualCreateTranslation;
  dashboard: DashboardViewTranslation;
  dictionaries: DictionariesViewTranslation;
  emails: EmailsViewTranslation;
  emergencyContacts: EmergencyContactsTranslation;
  failedWorkflowActions: FailedWorkflowActionsTranslation;
  offerDefinitions: OfferDefinitionsTranslation;
  processes: ProcessesTranslation;
  processesCreate: ProcessesCreateTranslation;
  processesDetails: ProcessesDetailsTranslation;
  processesUpdate: ProcessesUpdateTranslation;
  recurringReservations: RecurringReservationsTranslation;
  reports: ReportsTranslation;
  resourceCalendar: ResourceCalendarViewTranslation;
  roles: RolesTranslation;
  supervisors: SupervisorsTranslation;
  suppliers: SuppliersTranslation;
  tasks: TasksTranslations;
  users: UsersTranslation;
  util: UtilViewsTranslation;
};

export const viewsTranslation: ViewsTranslation = {
  cars: carsViewTranslation,
  chats: chatsViewTranslation,
  commissionAdministration: commissionAdministrationTranslation,
  commissionConfiguration: commissionConfigurationTranslation,
  commissions: commissionsTranslation,
  componentDefinitions: componentDefinitionsTranslation,
  contacts: contactsTranslation,
  contactsCreate: contactsCreateTranslation,
  contactsDetails: contactsDetailsTranslation,
  customerDetails: customerDetailsTranslation,
  customers: customersViewTranslation,
  customersBusinessCreate: customersBusinessCreateTranslation,
  customersForeignCreate: customersForeignCreateTranslation,
  customersIndividualCreate: customersIndividualCreateTranslation,
  dashboard: dashboardViewTranslation,
  dictionaries: dictionariesViewsTranslation,
  emails: emailsViewTranslation,
  emergencyContacts: emergencyContactsTranslation,
  failedWorkflowActions: failedWorkflowActionsTranslation,
  offerDefinitions: offerDefinitionsTranslation,
  processes: processesTranslation,
  processesCreate: processesCreateTranslation,
  processesDetails: processesDetailsTranslation,
  processesUpdate: processUpdateTranslation,
  recurringReservations: recurringReservationsTranslation,
  reports: reportsTranslation,
  resourceCalendar: resourceCalendarTranslation,
  roles: rolesTranslation,
  supervisors: supervisorsTranslation,
  suppliers: suppliersTranslation,
  tasks: tasksTranslations,
  users: usersTranslation,
  util: utilViewsTranslation,
};
